import { yup } from '@guiker/yup-util'

export const assetSchema = yup
  .object({
    id: yup.string().required(),
  })
  .required()

export const assetsSchema = yup.array().of(assetSchema)
